import { render, staticRenderFns } from "./workers_export.vue?vue&type=template&id=cafd67f6"
import script from "./workers_export.vue?vue&type=script&lang=js"
export * from "./workers_export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports